import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { ServerUrlService } from '../services/server-url.service'

/**
 * Anexa o token TOKEN_OTIMUS (header `token`) às chamadas do staff da fila de
 * atendimento. Escopo restrito: só as rotas travadas no backend
 * (filaAtendimento.js), e só quando batem no backend do cliente
 * (serverUrl.getUrl()) — nunca no CMS.
 */
@Injectable()
export class FilaTokenInterceptor implements HttpInterceptor {
  // Espelha rotasFila de otimus-node-atendimentoweb/app/middleware/filaAtendimento.js
  private readonly rotasFila = [
    '/usuarios/listaatende',
    '/usuarios/atendentes',
    '/usuarios/params_atende',
    '/service-queue',
    '/patient-queue-settings',
    '/atendimento/update-service-queue',
    '/atendimento/pegar-chegada-horario',
  ]

  constructor(
    private authService: AuthService,
    private serverUrl: ServerUrlService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const backendUrl = this.serverUrl.getUrl()
    const token = this.authService.getToken()

    const isBackendCall = !!backendUrl && req.url.startsWith(backendUrl)
    const isLockedRoute = this.rotasFila.some((rota) => req.url.includes(rota))

    if (token && isBackendCall && isLockedRoute) {
      const authReq = req.clone({ setHeaders: { token } })
      return next.handle(authReq)
    }

    return next.handle(req)
  }
}
